/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../../api/index';
import * as core from '../../../../../core';
import * as serializers from '../../../../index';

export const KeyUpdateLabelsRequest: core.serialization.Schema<
    serializers.KeyUpdateLabelsRequest.Raw,
    Omit<Truvity.KeyUpdateLabelsRequest, 'idempotencyKey' | 'ifMatch'>
> = core.serialization.object({
    labels: core.serialization.record(core.serialization.string(), core.serialization.string()),
});

export declare namespace KeyUpdateLabelsRequest {
    export interface Raw {
        labels: Record<string, string>;
    }
}
